import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {

  'plan_type': {
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002'
  }
}

export default {
  'gjahr': {
    title: '年度',
    type: 'year'
  },
  'sal_center': {
    describe: true,
    suffix: '_name',
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    width: 200
  },
  'plan_type': {
    describe: true,
    suffix: '_name',
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 200
  },
  'chfl': {
    describe: true,
    suffix: '_name',
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 200
  },
  'july_qty': {
    title: '7月计划量',
    formatter: ({ cellValue }) => Number(cellValue)
  },
  'july_adjqty': {
    title: '7月调整量',
    formatter: ({ cellValue, row }) => Number(row.july_minus ? -1 * cellValue : cellValue)
  },
  'august_qty': {
    title: '8月计划量',
    formatter: ({ cellValue }) => Number(cellValue)

  },
  'august_adjqty': {
    title: '8月调整量',
    formatter: ({ cellValue, row }) => Number(row.august_minus ? -1 * cellValue : cellValue)

  },
  'sep_qty': {
    title: '9月计划量',
    formatter: ({ cellValue }) => Number(cellValue)

  },
  'sep_adjqty': {
    title: '9月调整量',
    formatter: ({ cellValue, row }) => Number(row.sep_minus ? -1 * cellValue : cellValue)

  },
  'oct_qty': {
    title: '10月计划量',
    formatter: ({ cellValue }) => Number(cellValue)

  },
  'oct_adjqty': {
    title: '10月调整量',
    formatter: ({ cellValue, row }) => Number(row.oct_minus ? -1 * cellValue : cellValue)

  },
  'nov_qty': {
    title: '11月计划量',
    formatter: ({ cellValue }) => Number(cellValue)

  },
  'nov_adjqty': {
    title: '11月调整量',
    formatter: ({ cellValue, row }) => Number(row.nov_minus ? -1 * cellValue : cellValue)

  }
}



// WEBPACK FOOTER //
// ./src/views/contract-manage/config/contractPlanNumQuery.js